import { forwardRef } from 'react';

import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { WithChildren } from '../../core/types/with-children.js';
import { canReceiveDefaultTextFormat as _canReceiveDefaultTextFormat } from '../../core/utils/can-receive-default-text-format.js';
import { Flex } from '../../layouts/flex/Flex.js';
import { Text } from '../../typography/text/Text.js';

//#region Typings
/**
 * Accepted properties for the HealthIndicator Label.
 * @public
 */
export interface HealthIndicatorLabelProps
  extends WithChildren,
    StylingProps,
    DataTestId {}
//#endregion

/**
 * The label of the HealthIndicator component.
 * @public
 */
export const Label = forwardRef<HTMLDivElement, HealthIndicatorLabelProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
      ...remainingProps
    }: HealthIndicatorLabelProps = props;
    const childIsText = _canReceiveDefaultTextFormat(children);

    return (
      <Flex
        data-testid={dataTestId}
        ref={forwardedRef}
        className={consumerClassName}
        style={consumerStyle}
        {...remainingProps}
      >
        {childIsText ? <Text>{children}</Text> : children}
      </Flex>
    );
  },
);

(Label as typeof Label & { displayName: string }).displayName =
  'HealthIndicator.Label';
